module.exports = __webpack_public_path__ + "img/determine.4028b0bb.png";